import React from 'react';

/**
 * SEEN Beyond the Label - Official Logo
 * Human Movement Design: Adult figure with two children
 * Colors: Teal (#5DBDB3) and Coral (#F08B7D)
 */

export const SeenLogo = ({ className = '', size = 'md', showTagline = true }) => {
  const sizes = {
    sm: { width: 140, fontSize: 24, iconScale: 0.6 },
    md: { width: 200, fontSize: 32, iconScale: 0.8 },
    lg: { width: 280, fontSize: 42, iconScale: 1 },
    xl: { width: 360, fontSize: 54, iconScale: 1.2 }
  };

  const { width, fontSize, iconScale } = sizes[size] || sizes.md;

  return (
    <div className={`flex flex-col items-start ${className}`}>
      <div className="flex items-center gap-1">
        {/* SEEN Text */}
        <span 
          style={{ 
            fontFamily: 'Arial, sans-serif',
            fontSize: fontSize,
            fontWeight: '700',
            color: '#5DBDB3',
            letterSpacing: '2px'
          }}
        >
          SEEN
        </span>
        
        {/* Human Movement Icon */}
        <svg 
          width={60 * iconScale} 
          height={50 * iconScale} 
          viewBox="0 0 60 50" 
          fill="none"
        >
          {/* Center figure (adult with raised arms) */}
          <circle cx="30" cy="8" r="6" fill="#F08B7D"/>
          <path 
            d="M30 15 L30 32" 
            stroke="#F08B7D" 
            strokeWidth="4" 
            strokeLinecap="round"
          />
          <path 
            d="M30 18 C30 18 18 26 14 34" 
            stroke="#F08B7D" 
            strokeWidth="4" 
            strokeLinecap="round"
            fill="none"
          />
          <path 
            d="M30 18 C30 18 42 26 46 34" 
            stroke="#F08B7D" 
            strokeWidth="4" 
            strokeLinecap="round"
            fill="none"
          />
          
          {/* Left child figure */}
          <circle cx="14" cy="26" r="4" fill="#5DBDB3"/>
          <path 
            d="M14 31 L14 42" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
          <path 
            d="M14 35 L10 40" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
          <path 
            d="M14 35 L18 40" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
          
          {/* Right child figure */}
          <circle cx="46" cy="26" r="4" fill="#5DBDB3"/>
          <path 
            d="M46 31 L46 42" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
          <path 
            d="M46 35 L42 40" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
          <path 
            d="M46 35 L50 40" 
            stroke="#5DBDB3" 
            strokeWidth="3" 
            strokeLinecap="round"
          />
        </svg>
      </div>
      
      {/* Coral underline wave */}
      <svg 
        width={width * 0.7} 
        height={8} 
        viewBox="0 0 140 8" 
        fill="none"
        style={{ marginTop: -4, marginLeft: 2 }}
      >
        <path 
          d="M0 4 Q35 0 70 4 Q105 8 140 4" 
          stroke="#F08B7D" 
          strokeWidth="3" 
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      
      {/* Tagline */}
      {showTagline && (
        <span 
          style={{ 
            fontFamily: 'Arial, sans-serif',
            fontSize: fontSize * 0.4,
            fontWeight: '500',
            color: '#5DBDB3',
            marginTop: 4
          }}
        >
          Beyond the label.
        </span>
      )}
    </div>
  );
};

// Compact icon version for navbar
export const SeenIcon = ({ className = '', size = 32 }) => {
  const scale = size / 32;
  
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {/* SEEN Text */}
      <span 
        style={{ 
          fontFamily: 'Arial, sans-serif',
          fontSize: 18 * scale,
          fontWeight: '700',
          color: '#5DBDB3',
          letterSpacing: '1px'
        }}
      >
        SEEN
      </span>
      
      {/* Human Movement Icon - compact */}
      <svg 
        width={30 * scale} 
        height={24 * scale} 
        viewBox="0 0 30 24" 
        fill="none"
      >
        {/* Center figure */}
        <circle cx="15" cy="4" r="3" fill="#F08B7D"/>
        <path d="M15 8 L15 16" stroke="#F08B7D" strokeWidth="2" strokeLinecap="round"/>
        <path d="M15 10 C15 10 9 14 7 18" stroke="#F08B7D" strokeWidth="2" strokeLinecap="round" fill="none"/>
        <path d="M15 10 C15 10 21 14 23 18" stroke="#F08B7D" strokeWidth="2" strokeLinecap="round" fill="none"/>
        
        {/* Left child */}
        <circle cx="7" cy="13" r="2" fill="#5DBDB3"/>
        <path d="M7 16 L7 22" stroke="#5DBDB3" strokeWidth="1.5" strokeLinecap="round"/>
        
        {/* Right child */}
        <circle cx="23" cy="13" r="2" fill="#5DBDB3"/>
        <path d="M23 16 L23 22" stroke="#5DBDB3" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    </div>
  );
};

export default SeenLogo;
